import React from "react";
import ChangePasswordForm from './changePasswordForm';

const ChangePassword = () => {
    return (
        <div style={{ maxWidth: 400, margin: '40px auto' }}>
            <h2>Ubah Password</h2>
            <ChangePasswordForm />
        </div>
    );
};

export default ChangePassword;